import React, { useEffect } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "./HotelGallery.Module.css";
import { useTranslation } from "../../../../contexts/TranslationContext";


const HotelGallery = ({ hotel }) => {
    const { t } = useTranslation();
  
  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: false,
      Toolbar: false,
    });

    return () => {
      Fancybox.unbind();
      Fancybox.close();
    };
  }, []);

  
 const images = hotel?.Images ? [].concat(...hotel.Images) : [];

  const mainImages = images.slice(0, 3); // 3 main images
  const galleryImages = images.slice(3); // All remaining images go into Fancybox

  const [lat, lng] = hotel.Map.split("|");

  return (
    <div className="hotel-gallery-grid">
      {/* First big image */}
      <img src={mainImages[0]} alt={''} className="hotel-main-image" />

      {/* Two vertical images */}
      <div className="hotel-grid-column">
        <img src={mainImages[1]} alt={""} />
        <img src={mainImages[2]} alt={""} />
      </div>

      {/* Static Map + More Photos */}
      <div className="hotel-grid-column hotel-map-column">
        {/* Static Map */}
        <div className="hotel-map-container">
          <iframe
            title="Hotel Location"
            src={`https://www.google.com/maps?q=${lat},${lng}&hl=es;z=14&output=embed`}        
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
          {/* <a
            href={`https://www.google.com/maps?q=${lat},${lng}&hl=es;z=14&output=embed`}   
            target="_blank"
            rel="noopener noreferrer"
            className="map-button"
          >
            {t("ShowOnMap")}
          </a> */}
        </div>

        {/* +X PHOTOS (trigger) */}
        <a
          href={galleryImages[0].src}
          data-fancybox="gallery"
          data-srcset={`${galleryImages[0]} 1024w`}
          className="more-photos"
        >
          <img src={galleryImages[0]} alt={""} />
          <div className="overlay">+{galleryImages.length} {t("Photos")}</div>
        </a>

        {/* Hidden Fancybox images */}
        {galleryImages.map((img, index) => (
          <a
            key={`gallery-${index}`}
            href={img}
            data-fancybox="gallery"
            data-srcset={`${img} 1024w`}
            style={{ display: "none" }}
          >
            <img src={img} alt={""} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default HotelGallery;
